import { ISpecialist, ISpecialists } from '../../../types/specialist';
import { getSummaryRealtors, getSummaryAgencies, getSummaryDevelopers } from './summary';
import { SPECIALISTS_URLS } from '../constants';

interface ICreateSpecialistConfigParams {
  realtorsData: ISpecialist[];
  agenciesData: ISpecialist[];
  developersArray: ISpecialist[];
  developersTitle: string;
  developersUrl: string;
}

export const createSpecialistConfigs = ({
  realtorsData,
  agenciesData,
  developersArray,
  developersTitle,
  developersUrl,
}: ICreateSpecialistConfigParams): ISpecialists[] => [
  {
    key: 'realtor',
    title: 'Риелторы',
    specialists: realtorsData,
    url: SPECIALISTS_URLS.realtors,
    urlTitle: 'Все риелторы',
    isRoundPhoto: true,
    getSummary: getSummaryRealtors,
  },
  {
    key: 'agents',
    title: 'Агентства',
    specialists: agenciesData,
    url: SPECIALISTS_URLS.agencies,
    urlTitle: 'Все агентства',
    getSummary: getSummaryAgencies,
  },
  {
    key: 'developers',
    title: developersTitle,
    specialists: developersArray,
    url: developersUrl,
    urlTitle: 'Все застройщики',
    getSummary: getSummaryDevelopers,
  },
];
